<template>
  <v-simple-table :dense="tableDense">
    <template v-slot:default>
      <slot />
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['tableDense'])
  }
}
</script>
